export const DOMAIN_CBRE = 'cbre';

export const jobStatus = {
  ON_HOLD: 'Onhold',
  CLOSED: 'Closed',
  JOINED: 'Joined',
  OPEN: 'Open',
  DISABLED_STATUSES: [
    'L1 Rejected',
    'L2 Rejected',
    'L3 Rejected',
    'L4 Rejected',
    'L5 Rejected',
    'Profile Rejected',
    'Backed Out',
    'Candidate Dropped',
  ],
};

export const HIRING_REQUEST_TEXT = {
  overallExperienceError: 'Experience cannot exceed 40 years ',
  relevantExperienceError:
    'Relevant experience cannot exceed overall experience',
  requiredFieldError: 'This field cannot be blank',
};
export enum ErrorMessages {
  NoFileSelected = 'No file selected.',
  FileUploadFailed = 'File upload failed.',
  TokenExpired = 'Token expired. Attempting to refresh token...',
  TokenRefreshed = 'Token refreshed successfully',
  NoDataAvailable = 'No data available',
  NoVendorSelected = 'No vendor selected or invalid vendor ID',
  FailedToFetchLeaveSummary = 'Failed to fetch leave summary',
  UnexpectedError = 'An unexpected error occurred. Please try again later.',
  EmployeeIdNotFound = 'Employee ID not found. Cannot load vendor details.',
  FileSizeExceeded = 'File size exceeds the maximum allowed size of 10MB.',
  InvalidFileType = 'Invalid file type. Please upload a PDF or Word document.',
  FieldCannotBeBlank = 'This field cannot be blank.',
  FailedToLoadTimesheetData = 'Failed to load timesheet data.',
  FailedToFetchEmployeeDetails = 'Failed to fetch employee details.',
}

export enum FieldLabels {
  FileUpload = 'Select file(s) or drop here to upload',
  FileUploadHint = 'PDF or word formats, up to 10 MB.',
}

export const HeaderConstants = {
  brandText: 'CBRE IOP',
  help: {
    iconName: 'help_outline',
    notificationIconName: 'notifications',
    notificattionTitle: 'Notifications',
    title: 'Help & Support',
    supportMessage: 'For any support or issues, please contact our Team at',
    supportEmailLabel: 'D&T IOP',
    supportEmail: 'DT-IOP@cbre.com',
    closeIconName: 'close',
    noHelpMessage: 'All systems are running smoothly',
    contactSupportText: 'Contact Support',
    buttonLabels: {
      contactSupport: 'Contact Support'
    },
    messages: {
      viewingDetails: 'Viewing details for',
      notifyingAbout: 'Notifying about'
    },
    defaultHelpItems: [
      {
        id: 1,
        title: 'Technical Support',
        message: 'For any support or issues, please contact our Team at D&T IOP.',
        contact: 'DT-IOP@cbre.com',
        contactLabel: 'Technical Team',
        action: 'Contact Support'
      }
    ]
  },
  notifications: {
    iconName: 'notifications',
    title: 'Notifications',
    noNotificationsMessage: 'No new notifications',
    closeIconName: 'close'
  }
};

export const FooterConstants = {
  footerText: 'Copyright',
  allRightsText: 'CBRE. All rights reserved.',
  supportLabel: 'For any support or issues, please contact our Team at ',
  supportEmailLabel: 'D&T IOP',
  endLabel: '.',
};

export enum ErrorCode {
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  InternalServerError = 500,
}

export const employeeLevelCode = {
  LEVEL_ONE: 1,
  LEVEL_TWO: 2,
  LEVEL_THREE: 3,
  LEVEL_FOUR: 4,
  LEVEL_FIVE: 5,
  LEVEL_SIX: 6,
};

export const Months: string[] = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const HeadCount = {
  ten: 10,
  twenty: 20,
  thirty: 30,
  forty: 40,
  fifty: 50,
  sixty: 60,
};

export enum ButtonLabels {
  Cancel = 'Cancel',
  Submit = 'Submit',
  BrowseFile = 'Browse File',
  Comments = 'Add Comment',
}

export enum LeaveType {
  Paid = 'Paid Leave',
  Unpaid = 'Unpaid Leave',
  PublicHoliday = 'Public Holiday',
  HalfPaid = 'Half Paid Leave',
  HalfUnpaid = 'Half Unpaid Leave',
}

export enum AttendanceType {
  Office = 'Office Days',
  Remote = 'Remote Days',
  Absent = 'Absent Days',
  Holiday = 'Public Holidays',
}

export enum LeaveStatus {
  Paid = 'paid',
  Unpaid = 'unpaid',
  Public = 'public',
  PublicHoliday = 'public-holiday',
}

export enum LegendClass {
  Paid = 'paid-leave',
  Unpaid = 'unpaid-leave',
  PublicHoliday = 'public-holiday',
  HalfPaid = 'half-paid-leave',
  HalfUnpaid = 'half-unpaid-leave',
}

export enum AttendanceClass {
  Office = 'office-day',
  Remote = 'remote-day',
  Absent = 'absent-day',
  Holiday = 'public-holiday',
}

export const LEGEND_ITEMS = [
  { label: LeaveType.HalfPaid, class: LegendClass.HalfPaid },
  { label: LeaveType.Paid, class: LegendClass.Paid },
  { label: LeaveType.HalfUnpaid, class: LegendClass.HalfUnpaid },
  { label: LeaveType.Unpaid, class: LegendClass.Unpaid },
  { label: LeaveType.PublicHoliday, class: LegendClass.PublicHoliday },
];

export const Attendance_Items: CalendarLegendItem[] = [
  { label: AttendanceType.Office, class: AttendanceClass.Office },
  { label: AttendanceType.Remote, class: AttendanceClass.Remote },
  { label: AttendanceType.Absent, class: AttendanceClass.Absent },
  { label: AttendanceType.Holiday, class: AttendanceClass.Holiday },
];

// Optionally, you can alias for clarity:
export const RTO_CALENDAR_LEGEND = Attendance_Items;

export const LEAVE_TYPE_LIST = [LeaveType.Paid, LeaveType.Unpaid];

export const MONTH_PAD_THRESHOLD = 10;

export const VendorDropdownOptions = {
  deactivated: [
    { label: 'Update and resend', value: 'updateAndResend' },
    { label: 'Submit for account creation', value: 'submitForAccountCreation' },
  ],
  initiated: [
    { label: 'Cancel Invitation', value: 'cancelInvitation' },
    { label: 'Submit for account creation', value: 'submitForAccountCreation' },
  ],
  onboarded: [{ label: 'Disable Vendor', value: 'disableVendor' }],
};

export enum Priority {
  red = 'red',
  green = 'green',
  flag = 'flag',
  check = 'check',
  Critical = 'Critical',
  Standard = 'Standard',
}

export const DEFAULT_LEGEND_ITEMS = [
  { color: Priority.red, label: Priority.Critical },
  { color: Priority.green, label: Priority.Standard },
];

export const RTO_DATA = [
  { month: 'Jan 25', compliant: 36, nonCompliant: 35 },
  { month: 'Feb 25', compliant: 59, nonCompliant: 40 },
  { month: 'March 25', compliant: 30, nonCompliant: 25 },
  { month: 'April 25', compliant: 60, nonCompliant: 20 },
  { month: 'May 25', compliant: 75, nonCompliant: 40 },
];

export const GENERAL_COMPLIANCE = [
  {
    label: 'MSA Rate Card Exceptions',
    value: 0 as string | number,
    highlight: false,
    fileUrl: '',
  },
  {
    label: 'SoW Compliance',
    value: 0 as string | number,
    highlight: false,
    fileUrl: '',
  },
  {
    label: 'Invoice Compliance',
    value: 0 as string | number,
    highlight: false,
    fileUrl: '',
  },
  {
    label: 'Asset Compliance',
    value: 0 as string | number,
    highlight: false,
    fileUrl: '',
  },
 
];

export const Metrics = [
  {
    label: 'Number of Positions',
    value: 125,
  },
  {
    label: 'Speed of Closures-Days',
    value: 5,
  },
  {
    label: 'Voluntary Attrition',
    value: 5,
  },
  {
    label: 'Non-Voluntary Attrition',
    value: 5,
  },
  {
    label: 'No of Niche Skills',
    value: 11,
  },
  {
    label: 'Buffer Resources',
    value: 4,
  },
  {
    label: 'YTD CTH',
    value: 8,
  },
];


export const strategicPartnershipDisplayData = [
  {
    label: 'Investment for Strategic Programs',
    value: 0,
    fileUrl: '',
  },
  {
    label: 'Use Cases Co-Invented',
    value: 0,
    fileUrl: '',
  },
]

export const uploadControls = [
  'assetUpload',
  'sowUpload',
  'invoiceUpload',
  'msaUpload',
];

export const rating = [
  'technical', 'behavioural'
]

export const EXCEL_FILE_EXTENSION = [
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel.sheet.macroEnabled.12',
  'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
  'application/vnd.ms-excel.template.macroEnabled.12',
  'text/csv',
  'application/csv',
  'application/vnd.oasis.opendocument.spreadsheet',
  'application/vnd.oasis.opendocument.spreadsheet-template',
]

export const stars = [1, 2, 3, 4, 5];

export const feedbackQuarters = [
  { label: '1st Quarter, 2025', technical: 3, behavioural: 3, comments: '', submittedBy: '', submittedOn: '' },
  { label: '2nd Quarter, 2025', technical: 3, behavioural: 5, comments: '', submittedBy: '', submittedOn: '' },
  { label: '3rd Quarter, 2025', technical: 5, behavioural: 4, comments: '', submittedBy: '', submittedOn: '' },
  { label: '4th Quarter, 2025', technical: 4, behavioural: 5, comments: '', submittedBy: '', submittedOn: '' },
];


export const vendorOptions = [
  'Show All Vendors',
  'Admin Screen',
  'User Activity',
];

export const quarterss = ['Q1', 'Q2', 'Q3', 'Q4'];

export const quarters = [1, 2, 3, 4];

export const ContractorQuarterly = {
  profileError: 'User profile not found.',
  updateSuccess: 'Feedback updated successfully',
  saveSuccess: 'Feedback saved successfully',
  failedToLoadFeedback: 'Failed to load feedback data',
  updateError: 'Failed to update feedback data',
  saveError: 'Failed to save feedback data',
  loadError: 'Load Error',
  saveServiceError: 'Save Error',
  updateServiceError: 'Update Error',
  technical: 'techincalRating',
  behavioural: 'behaviouralRating',
  performance: 'performanceRating',
  submittedBy: 'Submitted By:',
  submittedOn: 'Submitted On:',
  addFeedback: 'Add Feedback',
  employeeInfoUpdated: 'Employee info updated',
  employeeInfoUpdateError: 'Failed to update employee info',
  employeePerformanceUpdated: 'Employee performance updated',
  employeePerformanceUpdateError: 'Failed to update employee performance',
  employeeSkillsUpdated: 'Employee skills updated',
  employeeSkillsUpdateError: 'Failed to update employee skills',
  employeeTeamInfoUpdated: 'Employee team info updated',
  employeeTeamInfoUpdateError: 'Failed to update employee team info',
  lastSpotAward: 'Last Spot Award',
};
export const CHART_CONFIG = {
  CANVAS: {
    MAX_SIZE: 350,
    MIN_SIZE: 280,
    DEFAULT_CONTAINER_SIZE: 300,
    OUTER_RADIUS_OFFSET: 50,
    INNER_RADIUS_RATIO: 0.75,
    LABEL_DISTANCE: 20,
    LABEL_MAX_WIDTH: 80,
    LABEL_LINE_HEIGHT: 12,
    TEXT_ALIGNMENT_THRESHOLD: 15
  },
  CHART: {
    MIN_CANVAS_SIZE: 400,
    OUTER_RADIUS_OFFSET: 40,
    CHART_OFFSET: 100,
    INNER_RADIUS_RATIO: 0.65,
    LABEL_RADIUS_OFFSET: 20,
    BRIGHTNESS_FACTOR: 1.1
  },
  TOOLTIP: {
    PADDING: 12,
    COLOR_SQUARE_SIZE: 12,
    HEIGHT: 45,
    DISTANCE_OFFSET: 50,
    MARGIN: 10,
    COLOR_COUNT_SPACING: 8,
    BORDER_SPACING: 4,
    BORDER_WIDTH: 1,
    BACKGROUND_OPACITY: 0.9
  },
  ANIMATION: {
    SPEED: 0.02,
    DELAY: 100,
    MOCK_API_DELAY: 500
  },
  FONTS: {
    FAMILY: 'Calibre',
    COUNT_SIZE: '12px',
    COUNT_WEIGHT: '500',
    LABEL_SIZE: '10px',
    LABEL_WEIGHT: '400',
    TOOLTIP_NAME_SIZE: '14px',
    TOOLTIP_NAME_WEIGHT: '400',
    TOOLTIP_COUNT_SIZE: '16px',
    TOOLTIP_COUNT_WEIGHT: 'bold',
    LABEL_COUNT_SIZE: '16px',
    LABEL_COUNT_WEIGHT: 'bold',
    NO_DATA_SIZE: '16px',
    NO_DATA_WEIGHT: '400'
  },
  COLORS: {
    STROKE: 'var(--chart-stroke-color)',
    TEXT: 'var(--chart-label-color)',
    NO_DATA_TEXT: 'var(--chart-no-data-text-color)',
    WHITE: '#ffffff',
    BLACK: '#000000',
    TOOLTIP_BACKGROUND: 'rgba(0, 0, 0, 0.9)'
  },
  STROKE: {
    WIDTH: 0,
    CHART_WIDTH: 2,
    CAP: 'round' as CanvasLineCap,
    JOIN: 'round' as CanvasLineJoin
  }
};

export const CHART_MESSAGES = {
  NO_DATA_AVAILABLE: 'No Data Available',
  LOADING_VENDOR_DATA: 'Loading Vendor Data...',
  NO_VENDOR_DATA: 'No Vendor Data available',
  UNKNOWN_VENDOR: 'Unknown Vendor'
};

export const EMPLOYEE_CONFIG = {
  DEFAULT_ID: 'C0034028'
};

export const CHART_COLORS = {
  PRIMARY: [
    'var(--chart-primary-brown)',
    'var(--chart-primary-cadet-blue)',
    'var(--chart-primary-royal-blue)',
    'var(--chart-primary-blue-violet)',
    'var(--chart-primary-tomato)',
    'var(--chart-primary-lime-green)',
    'var(--chart-primary-gold)',
    'var(--chart-primary-hot-pink)'
  ],
  SECONDARY: [
    'var(--chart-secondary-red)',
    'var(--chart-secondary-blue)',
    'var(--chart-secondary-yellow)',
    'var(--chart-secondary-teal)',
    'var(--chart-secondary-purple)',
    'var(--chart-secondary-orange)'
  ]
};

export interface CalendarLegendItem {
  label: string;
  class: string;
}

export const RTO_DETAILS_CONFIG = {
  Dashboard : 'Dashboard / RTO',
  Information: 'RTO Information',
  Font_Size: 1.4,
  Comment: 'Comment',
  teamManagement: '/team-management'
}

export const TeamCompositionListInfo = {
  teamManagementinfo: '/team-management/team-composition',
  FailedToLoadTeamCompositionData: 'Failed to load teamComposition data.',
}

export const STATUSCONSTANTS = {
  PENDING: 'Pending',
  DONE: 'Done',
  INITIATED: 'Initiated',
  CANCELLED: 'Cancelled',
  READY: 'Ready',
  DELIVERED: 'Delivered',
  COST_RECEIVED: 'Cost Received',
  EXCEPTION_RECEIVED: 'Exception Received',
  COMPLETED: 'Completed',
  iN_PROGRESS: 'In Progress',
};
export const ASSET_MANAGEMENT_CONSTANTS = {
  inVoluntary: 'Involuntary',
};